import { NEW_TAB } from '../../lib/external.js';
import { PageFrame } from '../../layout/page-frame.js';
import { REPO_URL } from '../../layout/top-bar.js';

const LINKS: [string, string, string][] = [
  [
    'Versioning and compatibility',
    'docs/governance/versioning.md',
    'Semver rules, release channels, the compatibility matrix.',
  ],
  ['Deprecation policy', 'docs/governance/deprecation.md', 'Mark, warn, wait, remove.'],
  [
    'Exceptions',
    'docs/governance/exceptions.md',
    'Time-limited, owned deviations from conformance rules.',
  ],
  ['Conformance', 'docs/guides/conformance.md', 'Rules, baseline ratchet, CI integration.'],
  [
    'Component contract',
    'docs/guides/component-contract.md',
    'What every public component guarantees.',
  ],
  ['Brand', 'docs/guides/brand.md', 'The official palette and how Monarch uses it.'],
  ['Architecture decisions', 'docs/adr', 'Why things are the way they are.'],
  ['Product status report', 'docs/registry/STATUS.md', 'Generated by monarch registry report.'],
  ['For AI coding agents', 'AGENTS.md', 'Rules for agents working in Rook apps or in Monarch.'],
];

export function GovernancePage() {
  return (
    <PageFrame
      eyebrow="Guides"
      title="Governance"
      lead="Monarch is the source of truth. These policies say how it changes and how products stay aligned."
      toc={false}
    >
      <div className="docs-table-scroll">
        <table className="docs-table">
          <thead>
            <tr>
              <th scope="col">Policy</th>
              <th scope="col">What it covers</th>
            </tr>
          </thead>
          <tbody>
            {LINKS.map(([title, path, what]) => (
              <tr key={path}>
                <td>
                  <a {...NEW_TAB} href={`${REPO_URL}/blob/main/${path}`}>
                    {title}
                  </a>
                </td>
                <td>{what}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </PageFrame>
  );
}
